/*
 * Settings > Users > a person's sign-in security (ADR 0037). Facts as label and value pairs,
 * then the actions in a row that wraps on narrow screens. Tokens only.
 */

.facts {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--space-2) var(--space-5);
  margin: 0;
}

.facts dt {
  color: var(--pencil);
  font: var(--t-small);
}

.facts dd {
  margin: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: center;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

.list li {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
